module.exports = __webpack_public_path__ + "static/img/other-collectbg.bc8b707c.png";